import { O2Loader } from 'o2-theme-react';
import React, { useEffect } from 'react';
import { I18n } from 'react-i18nify-lite';

//Recover page was migrated to ume-v2 this is just backup redirect for case of old links
const RecoverRedirect: React.FC = () => {

  useEffect(() => {
    window.location.href = (window as any).g_newRecoverPageUrl + window.location.search;
  }, []);

  return (
    <O2Loader>{I18n.t('ume.ext.registration.start.loading')}</O2Loader>
  );
};

export default RecoverRedirect;